import React, { useState, useCallback, useEffect } from 'react';
import { Form, Button, Icon, Segment, Header } from 'semantic-ui-react';

const RcmEnrichmentToggles = React.memo(({ config, isLoading, onConfigUpdate }) => {
  const settings = config?.settings || {};

  const [enrichVehicleData, setEnrichVehicleData] = useState(settings.enrichVehicleData !== false);
  const [enrichDamages, setEnrichDamages] = useState(settings.enrichDamages !== false);
  const [enrichNextBooking, setEnrichNextBooking] = useState(settings.enrichNextBooking !== false);

  useEffect(() => {
    const s = config?.settings || {};
    setEnrichVehicleData(s.enrichVehicleData !== false);
    setEnrichDamages(s.enrichDamages !== false);
    setEnrichNextBooking(s.enrichNextBooking !== false);
  }, [config?.settings]);

  const handleSave = useCallback(() => {
    onConfigUpdate({
      enrichVehicleData,
      enrichDamages,
      enrichNextBooking,
    });
  }, [enrichVehicleData, enrichDamages, enrichNextBooking, onConfigUpdate]);

  return (
    <Segment>
      <Header as="h4" style={{ marginBottom: '15px' }}>
        <Icon name="sliders horizontal" />
        <Header.Content>
          Data Enrichment
          <Header.Subheader>Choose what extra data to include per booking card</Header.Subheader>
        </Header.Content>
      </Header>

      <Form>
        <Form.Checkbox
          toggle
          label="Vehicle Data (odometer, fuel level, battery voltage)"
          checked={enrichVehicleData}
          onChange={(e, { checked }) => setEnrichVehicleData(checked)}
          disabled={isLoading}
          style={{ marginBottom: '12px' }}
        />
        <Form.Checkbox
          toggle
          label="Vehicle Damages"
          checked={enrichDamages}
          onChange={(e, { checked }) => setEnrichDamages(checked)}
          disabled={isLoading}
          style={{ marginBottom: '12px' }}
        />
        <Form.Checkbox
          toggle
          label="Next Booking Info"
          checked={enrichNextBooking}
          onChange={(e, { checked }) => setEnrichNextBooking(checked)}
          disabled={isLoading}
          style={{ marginBottom: '12px' }}
        />

        <small style={{ color: '#888', display: 'block', marginBottom: '12px' }}>
          Enrichment adds ~2-3 seconds per booking during import
        </small>

        <Button
          primary
          size="small"
          onClick={handleSave}
          loading={isLoading}
          disabled={isLoading}
          icon="save"
          content="Save Enrichment Settings"
        />
      </Form>
    </Segment>
  );
});

RcmEnrichmentToggles.displayName = 'RcmEnrichmentToggles';

export default RcmEnrichmentToggles;
